// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","mainSection":"Ga31aa1","paddingElement":"Gd91742","orderedList":"G5b5e14","itemList":"G42f409"};